module.exports = __webpack_public_path__ + "img/guide3.d0ff6cac.png";